function AutocompleterItemCtrl() {}
;
export default AutocompleterItemCtrl;